<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container">
    <div class="left-container">
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Basic Information
        </div>
        <div class="section-content">
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" required [readonly]="!isCreateMode">
            </mat-form-field>
          </div>
          <div class="form-field-container" *ngIf="isCreateMode">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Password</mat-label>
              <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" required>
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!hidePassword">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="form-field-container" *ngIf="isCreateMode">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Confirm Password</mat-label>
              <input matInput formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'" required>
              <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" type="button" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!hideConfirmPassword">
                <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Full Name</mat-label>
              <input matInput formControlName="fullName" required>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Role</mat-label>
              <mat-select formControlName="role" required placeholder="Select Role">
                <mat-option value="Administrator">
                  Administrator
                </mat-option>
                <mat-option value="Leader">
                  Leader
                </mat-option>
                <mat-option value="User">
                  User
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-container" *ngIf="!isCreateMode">
            <mat-checkbox formControlName="active">Active</mat-checkbox>
          </div>
          <div class="form-field-container" *ngIf="!isCreateMode && (createdDate || updatedDate)">
            <div style="color: rgba(0, 0, 0, 0.6); font-size: 12px; margin-top: 8px;">
              <div *ngIf="createdDate"><strong>Created:</strong> {{ createdDate | date:'medium' }}</div>
              <div *ngIf="updatedDate" style="margin-top: 4px;"><strong>Updated:</strong> {{ updatedDate | date:'medium' }}</div>
            </div>
          </div>
        </div>
      </section>
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Options
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Category</mat-label>
                <mat-select formControlName="category" placeholder="Select category">
                  <mat-option value="None">None</mat-option>
                  <mat-option value="Audit">Audit</mat-option>
                  <mat-option value="Compensation">Compensation</mat-option>
                  <mat-option value="Corporate governance">Corporate governance</mat-option>
                  <mat-option value="CSR">ESG</mat-option>
                  <mat-option value="Voting results">Voting results</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </section>
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Access
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select formControlName="selectedTabs" placeholder="Select Tabs" multiple [compareWith]="compareTabsByName">
                  <mat-option *ngFor="let tab of tabs" [value]="tab">
                    {{ tab.name }}
                  </mat-option>
                  <mat-select-trigger>
                    <ng-container *ngIf="form.get('selectedTabs')?.value as selected">
                      {{selected[0] ? getTabName(selected[0]) : ''}}
                      <span *ngIf="selected.length > 1" class="additional-count">
                        +{{selected.length - 1}} more
                      </span>
                    </ng-container>
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button type="button" (click)="selectAllTabs()" matTooltip="Select all tabs">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="deselectAllTabs()" matTooltip="Deselect all tabs">
                <mat-icon>deselect</mat-icon>
              </button>
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected tabs">
              <mat-chip [ngClass]="getTabChipClass(tab)" *ngFor="let tab of getSelectedTabsArray()" (click)="toggleTab(tab)"
                matTooltip="Click to switch between full access and read-only">
                {{ getTabName(tab) }} {{ isTabReadonly(tab) ? '(Readonly)' : '' }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </section>
      </div>
      <div class="right-container">
        <div>
          <section class="section-container nrg-border-radius">
            <div class="section-header">
              <span>Sections</span>
              <div class="header-buttons">
                <button mat-icon-button type="button" (click)="selectAllSections()" matTooltip="Select all sections">
                  <mat-icon>select_all</mat-icon>
                </button>
                <button mat-icon-button type="button" (click)="deselectAllSections()" matTooltip="Deselect all sections">
                  <mat-icon>deselect</mat-icon>
                </button>
              </div>
            </div>
            <div class="section-content">
              <div style="height: 300px; overflow: auto;">
                <mat-expansion-panel class="section-panel" *ngFor="let section of sections; let i = index">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="section-panel-title">{{ section.displayName }} {{ getNumberOfSelectedSubsections(section) }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-nav-list>
                    <div class="section-panel-item" *ngFor="let child of section.children">
                      <mat-icon *ngIf="isSectionSelected(section.displayName, child.displayName)" matListItemIcon (click)="toggleSection(section.displayName, child.displayName)">check_box</mat-icon>
                      <mat-icon *ngIf="!isSectionSelected(section.displayName, child.displayName)" matListItemIcon (click)="toggleSection(section.displayName, child.displayName)">check_box_outline_blank</mat-icon>
                      <span matListItemTitle style="width: 50%;" (click)="toggleSection(section.displayName, child.displayName)">{{ child.displayName }}</span>
                      <mat-icon [ngClass]="getAddSectionIconClass(section.displayName, child.displayName)" class="section-panel-item-icon" (click)="addSection(section.displayName, child.displayName)">add_box</mat-icon>
                      <mat-icon [ngClass]="getEditSectionIconClass(section.displayName, child.displayName)" class="section-panel-item-icon" (click)="editSection(section.displayName, child.displayName)">edit</mat-icon>
                      <mat-icon [ngClass]="getDeleteSectionIconClass(section.displayName, child.displayName)" class="section-panel-item-icon" (click)="deleteSection(section.displayName, child.displayName)">delete</mat-icon>
                    </div>
                  </mat-nav-list>
                </mat-expansion-panel>
              </div>
            </div>
          </section>
          <section class="section-container nrg-border-radius">
          <div class="section-header">
            Countries
          </div>
          <div class="section-content">
            <div class="section-field">
              <div class="select-with-button">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-select formControlName="selectedCountries" placeholder="Select Countries" multiple>
                    <mat-option *ngFor="let country of countries$ | async" [value]="country.id">
                      {{ country.name }}
                    </mat-option>
                    <mat-select-trigger>
                      <ng-container *ngIf="form.get('selectedCountries')?.value as selected">
                        {{selected[0] ? getCountryName(selected[0]) : ''}}
                        <span *ngIf="selected.length > 1" class="additional-count">
                          +{{selected.length - 1}} more
                        </span>
                      </ng-container>
                    </mat-select-trigger>
                  </mat-select>
                </mat-form-field>
                <button mat-icon-button type="button" (click)="selectAllCountries()" matTooltip="Select all countries">
                  <mat-icon>select_all</mat-icon>
                </button>
                <button mat-icon-button type="button" (click)="deselectAllCountries()" matTooltip="Deselect all countries">
                  <mat-icon>deselect</mat-icon>
                </button>
              </div>
            </div>
            <div class="section-selections">
              <mat-chip-set aria-label="Selected countries">
                <mat-chip class="chip-basic-item" *ngFor="let countryId of getSelectedCountriesArray()">
                  {{ getCountryName(countryId) }}
                </mat-chip>
              </mat-chip-set>
            </div>
          </div>
        </section>
        <section class="section-container nrg-border-radius">
        <div class="section-header">
          Measurements
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select formControlName="selectedMeasurements" placeholder="Select Measurements" multiple [compareWith]="compareMeasurements">
                  <mat-option *ngFor="let measurement of measurements" [value]="measurement">
                    {{ measurement }}
                  </mat-option>
                  <mat-select-trigger>
                    <ng-container *ngIf="form.get('selectedMeasurements')?.value as selected">
                      {{selected[0] ? getMeasurementName(selected[0]) : ''}}
                      <span *ngIf="selected.length > 1" class="additional-count">
                        +{{selected.length - 1}} more
                      </span>
                    </ng-container>
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button type="button" (click)="selectAllMeasurements()" matTooltip="Select all measurements">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="deselectAllMeasurements()" matTooltip="Deselect all measurements">
                <mat-icon>deselect</mat-icon>
              </button>
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected measurements">
              <mat-chip class="chip-basic-item" *ngFor="let measurementId of getSelectedMeasurementsArray()">
                {{ getMeasurementName(measurementId) }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </section>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <button mat-flat-button color="primary" type="button" (click)="onSubmit()" [disabled]="!form.valid">
      <mat-icon>save</mat-icon>
      {{ submitButtonText }}
    </button>
    <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
      <mat-icon>clear</mat-icon>
      Cancel
    </button>
  </div>
</form>
